module.exports = __webpack_public_path__ + "static/img/take-express_fill.a826981c.png";